module.exports = __webpack_public_path__ + "media/images/camera-btn-85c8425fb34b1b3ef92cbdcf3b74d2cf.svg";